import PropTypes from "prop-types";

const propTypes = {
  odberneMiesto: PropTypes.shape({
    I_ZIS_OM: PropTypes.number,
    I_ZMLUVY: PropTypes.number,
    I_ORGAN: PropTypes.number,
    NAZOV: PropTypes.string,
    ADRESA_ODBERU: PropTypes.string,
    C_OM: PropTypes.number,
    PLOCHA_SKUTOCNA: PropTypes.number,
    PLOCHA_VYKUROVANA: PropTypes.number,
    POCET_OSOB: PropTypes.number,
  }),
};

export default propTypes;
